import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Table, Icon, Tooltip } from 'antd';
import { objTypeAndClassTypeMap } from 'config/app.config';
import { connect } from 'react-redux';
import { Panel } from 'components/ui/index';
import { injectIntl } from 'react-intl';
import { toTimezone } from 'utils/dateTimeUtils';
import TopActions from '../component/TopActions';
import { queryByCondition, fetchTeamMembers, setTaskOrderByQueryText } from '../flow/action';
import { tryUpdateTask } from '../../../components/page/TaskDetails/flow/actions';

class TaskListView extends React.Component {
  componentDidMount() {
    const {
      dispatchFetchTeamMembers
    } = this.props;
    dispatchFetchTeamMembers();
  }

  getPriorities(p) {
    const { priorities } = this.props;
    const s = _.find(priorities, { id: p });
    if (!_.isEmpty(s)) return s.display_value;
    return '';
  }
  getStatus(statusCode) {
    const { taskStatus } = this.props;
    const s = _.find(taskStatus, { id: statusCode });
    if (!_.isEmpty(s)) return s.display_value;
    return '';
  }

  handleTableChange = (pagination, filter, sorter) => {
    const { dispatchQueryByCondition, teamMembers } = this.props;
    let condition = {};
    if (!_.isEmpty(pagination)) {
      const { pageSize, current } = pagination;
      condition = {
        ...condition,
        perPage: pageSize,
        currentPage: current,
      };
    }
    if (!_.isEmpty(sorter)) {
      const { order, field } = sorter;
      const orderByQueryText = `${field}:${order === 'ascend' ? 'asc' : 'desc'}`;
      this.props.setTaskOrderByQueryText(orderByQueryText);
      condition = {
        ...condition,
        orderBy: orderByQueryText
      };
    } else {
      this.props.setTaskOrderByQueryText('');
    }
    condition = {
      ...condition,
      memberIds: teamMembers.activeMember,
    };
    dispatchQueryByCondition(condition);
  }

  render() {
    const {
      taskDataTablePagination,
      tasks,
      dispatchTryUpdateTask,
    } = this.props;
    const { formatMessage } = this.props.intl;

    const handleCompleteWithTaskHistory = (record) => {
      const targetData = {
        // column assign_to_user_id decide whether this data should appear in task history, if value is passed, it will shown in task history.
        comments: record.comments,
        due_date: record.due_date,
        priority_code: record.priority_code,
        status_code: '1',
        subject: record.subject,
        taskable_id: record.relate_user ? record.relate_user.id : null,
        taskable_type: record.taskable_type,
      };
      dispatchTryUpdateTask(record.id, targetData, 'complete');
    };

    const columns = [
      {
        title: formatMessage({ id: 'global.ui.table.complete' }),
        key: 'id',
        render: record => (
          <Tooltip
            placement="topLeft"
            title={formatMessage({ id: 'global.ui.button.closeTask' })}
          >
            <a onClick={() => handleCompleteWithTaskHistory(record)}>
              <Icon type="close" />
            </a>
          </Tooltip>
        ),
      }, {
        title: formatMessage({ id: 'page.task.assignTo' }),
        key: 'assigner',
        render: record => (
          record.assigner && record.assigner.name ? <span>{record.assigner.name}</span> : '-'
        ),
      }, {
        title: formatMessage({ id: 'page.taskDetails.labels.subject' }),
        render: record => (
          record.relate_user ? (
            <Link to={`/${record.taskable_type}/${record.relate_user.id}/tasks/${record.id}`}>
              {record.subject}
            </Link>
          ) :
            <a
              onClick={() => handleCompleteWithTaskHistory(record)}
            >
              {record.subject}
            </a>
        ),
      }, {
        title: formatMessage({ id: 'page.comInfo.country' }),
        render: record => (
          record.relate_user ? (
            <span>
              {record.relate_user.country}
            </span>
          ) : ''
        )
      }, {
        dataIndex: 'comments',
        className: 'truncate',
        width: '15%',
        title: formatMessage({ id: 'global.ui.table.comment' }),
        render: text => (
          <Tooltip placement="topLeft" title={text}>
            {text}
          </Tooltip>
        )
      }, {
        title: formatMessage({ id: 'page.taskDetails.labels.dueDate' }),
        sorter: true,
        dataIndex: 'due_date',
        key: 'due_date',
        render: text => toTimezone(text),
      }, {
        title: formatMessage({ id: 'global.ui.table.relatedTo' }),
        render: record => (
          record.relate_user ? (
            <Link to={`${record.taskable_type}/${record.relate_user && record.relate_user.id}`}>
              <span className={`${objTypeAndClassTypeMap[record.taskable_type]}-theme-text`}>
                {record.relate_user.name}
              </span>
            </Link>
          ) : <span className={`${objTypeAndClassTypeMap[record.taskable_type]}-theme-text`}>-</span>
        ),
      }, {
        title: formatMessage({ id: 'global.ui.table.status' }),
        render: record => <span>{this.getStatus(record.status_code)}</span>,
      }, {
        title: formatMessage({ id: 'page.taskDetails.labels.priority' }),
        sorter: true,
        dataIndex: 'priority_code',
        render: priorityCode => <span>{this.getPriorities(priorityCode)}</span>,
      }, {
        title: formatMessage({ id: 'global.ui.table.createDate' }),
        sorter: true,
        dataIndex: 'created_at',
        render: text => toTimezone(text, true),
      }, {
        title: formatMessage({ id: 'global.ui.table.updatedAt' }),
        sorter: true,
        dataIndex: 'updated_at',
        render: text => toTimezone(text, true),
      },
    ];

    const pagination = {
      defaultCurrent: taskDataTablePagination.currentPage,
      current: taskDataTablePagination.currentPage,
      defaultPageSize: taskDataTablePagination.perPage,
      pageSize: taskDataTablePagination.perPage,
      total: taskDataTablePagination.total,
      size: 'small',
    };
    return (
      <Panel panelTitle={formatMessage({ id: 'page.task.myOpenActivity' })} contentClasses="pt-lg pb-lg pl-lg pr-lg">
        <TopActions />
        <Table
          onChange={this.handleTableChange}
          dataSource={tasks}
          columns={columns}
          pagination={pagination}
          className="fixedTable"
          rowKey="id"
          size="small"
        />
      </Panel>
    );
  }
}

const mapStateToProps = ({ task, global }) => ({
  ...task,
  priorities: global.settings.priorities,
  taskStatus: global.settings.statuses,
  teamMembers: task.teamMembers,
});
const mapDispatchToProps = {
  dispatchQueryByCondition: queryByCondition,
  dispatchTryUpdateTask: tryUpdateTask,
  dispatchFetchTeamMembers: fetchTeamMembers,
  setTaskOrderByQueryText
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(TaskListView)));



// WEBPACK FOOTER //
// ./src/views/Task/container/index.jsx